var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"load"},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary","height":"2"}}),_c('div',{staticClass:"text-center text-caption px-4 pt-2"},[_vm._v("\n        Carregando mais opções...\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }